import { Component, Input } from '@angular/core';

@Component({
  selector: 'ubs-order-contacts',
  templateUrl: './order-contacts.component.html',
  styleUrls: ['./order-contacts.component.scss']
})
export class OrderContactsComponent {
  @Input() orderId:string;
}
